<form novalidate
  [formGroup]="_form"
  (keydown.enter)="$event.preventDefault()"
  class="form_style">
  <div class="row">
    <div class="col-12">
      <div class="transaction-section-header">
        <div class="transaction-section-header-title">Cycle Count</div>
      </div>
    </div>
  </div>
  <div class="row no-row-margin">
    <div class="col-12 col-lg-4">
      <div class="form-group special_style_formgroup">
        <div class="row">
          <div class="col-2">
            <label class="control-label">Percentage</label>
          </div>
          <div class="col-10 transaction-input-fields">
            <kendo-numerictextbox
              [step]="0.1"
              format="p"
              [min]="0"
              [max]="1"
              style="width: 100%;"
              formControlName="percentageReport"
              (change)="percentageReportChange($event)"
              >
            </kendo-numerictextbox>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-4">
            <button kendoButton style="background-color: #E8E6E3 !important;
                                        color: blue;
                                        font-weight: 700;
                                        padding:5px 30px !important;
                                        border-radius: 10px;"
        (click)="_percentageReport()">Percentage Report
      </button>
    </div>
    <hr>
      <div class="col-12 col-lg-6 small-pad-right">
        <div class="transactionWidget">
          <div class="row">
            <div class="col-12">
              <div class="d-flex justify-content-between">
                <p class="titleStandardStyle">Step 1</p>
              <p class="titleStandardStyle" style="background-color: blue;
                                                    border-radius: 50%;
                                                    color: white;
                                                    padding: 5px;">{{_totalPercentage}}</p>
              </div>
            </div>
            <div class="col-12 margin-top-10">
              <div class="form-group special_style_formgroup">
                <div class="row">
                  <div class="col-2">
                    <label class="control-label">Date-Time</label>
                  </div>
                  <div class="col-10 transaction-input-fields">
                    <kendo-datetimepicker #kendo_Start_Date_Time_Piker
                      formControlName="transactionDate"
                      class="newFormControlWidth"
                      (valueChange)="_startDateSubmited()"
                      (open)="_startDateOpened()"
                      placeholder="Start Date and Time"
                      [format]="_datePickerFormat">
                    </kendo-datetimepicker>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 margin-top-10">
              <div class="form-group special_style_formgroup">
                <div class="row">
                  <div class="col-2">
                  </div>
                  <div class="col-10 transaction-input-fields">
                    <p>
                      <kendo-radiobutton
                        #assetItemBtn
                        [value]="1"
                        formControlName="countType"
                      ></kendo-radiobutton>
                      <kendo-label
                        class="k-radio-label"
                        [for]="assetItemBtn"
                        text="Item"
                      ></kendo-label>
                    </p>
                    <p>
                      <kendo-radiobutton
                        #locationRadioBtn
                        [value]="2"
                        formControlName="countType"
                      ></kendo-radiobutton>
                      <kendo-label
                        class="k-radio-label"
                        [for]="locationRadioBtn"
                        text="Location **"
                      ></kendo-label>
                    </p>
                    <p>
                      <kendo-radiobutton
                        #personRadioBtn
                        [value]="3"
                        formControlName="countType"
                      ></kendo-radiobutton>
                      <kendo-label
                        class="k-radio-label"
                        [for]="personRadioBtn"
                        text="Person"
                      ></kendo-label>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 margin-top-10">
              <div class="form-group special_style_formgroup">
                <div class="row">
                  <div class="col-2">
                    <label class="control-label">Percentage</label>
                  </div>
                  <div class="col-10 transaction-input-fields">
                    <kendo-numerictextbox
                      [step]="0.1"
                      format="p"
                      [min]="0"
                      [max]="_maxChunkPercentage"
                      formControlName="percentage"
                      [disabled]="true"
                      (change)="percentageChange($event)"
                      >
                    </kendo-numerictextbox>
                  </div>
                </div>
              </div>
            </div>
            <hr>
              <label class="control-label">* This will run by a percentage of items within locations.</label>
              <hr>
                <label class="control-label">** This will run by a percentage of locations that have items in them.</label>
                <label class="control-label px-4">This option can split up same inventory ID #'s that are in different locations.</label>
              </div>
            </div>
          </div>
          <div class="col-12 col-lg-3 small-pad-left">
            <div class="transactionWidget"
              (click)="_listboxClicked()"
              [class.active]="_addClassActiveLocation">
              <div class="row">
                <div class="col-12">
                  <p class="titleStandardStyle withPadding">Step 2</p>
                </div>
                <div class="col-12">
            <button kendoButton style="background-color: #E8E6E3 !important;
                                        color: blue;
                                        font-weight: 700;
                                        padding:5px 30px !important;
                                        margin: 10px 25px;
                                        border-radius: 10px;
                                        width:90%"
                    [disabled]="_isDrafted"
                    (click)="_startCycleCount()">Start Cycle Count
                  </button>
                  @if (_cycleCountGridData.length > 0) {
                    <div class="d-flex">
                <button kendoButton style="background-color: #E8E6E3 !important;
                                          color: blue;
                                          font-weight: 700;
                                          padding:5px 30px !important;
                                          margin: 10px 25px;
                                          border-radius: 10px;"
                        [disabled]="_isDrafted"
                        (click)="_reset()">Reset
                      </button>
              <button kendoButton style="background-color: #E8E6E3 !important;
                                          color: blue;
                                          font-weight: 700;
                                          padding:5px 30px !important;
                                          margin: 10px 10px;
                                          border-radius: 10px;"
                        (click)="_print()">Print
                      </button>
                    </div>
                    <div class="d-flex">
                <button kendoButton style="background-color: #E8E6E3 !important;
                                          color: blue;
                                          font-weight: 700;
                                          padding:5px 30px !important;
                                          margin: 10px 25px;
                                          border-radius: 10px;"
                        (click)="_email()">Email
                      </button>
              <button kendoButton style="background-color: #E8E6E3 !important;
                                          color: blue;
                                          font-weight: 700;
                                          padding:5px 30px !important;
                                          margin: 10px 10px;
                                          border-radius: 10px;"
                        (click)="_export()">Export
                      </button>
                    </div>
                    <hr>
                      <label class="control-label">* To begin, enter quantities for the items listed below. Once all quantities are entered, click Process in step 3.</label>
                    }
                  </div>
                </div>
              </div>
            </div>
            @if (_cycleCountGridData.length > 0) {
              <div class="col-12 col-lg-3 small-pad-left">
                <div class="transactionWidget"
                  (click)="_step3Clicked()"
                  [class.active]="_addClassActive3">
                  <div class="row">
                    <div class="col-12">
                      <p class="titleStandardStyle withPadding">Step 3</p>
                    </div>
                    <div class="col-12 mt-2">
                      <kendo-label text="Cycle Name">
                        <kendo-textbox formControlName="cycleName"></kendo-textbox>
                      </kendo-label>
                    </div>
                    <div class="col-12">
            <button kendoButton style="background-color: #E8E6E3 !important;
                                        color: blue;
                                        font-weight: 700;
                                        padding:5px 30px !important;
                                        margin: 10px 25px;
                                        border-radius: 10px;
                                        width:90%"
                        (click)="_process()">Process
                      </button>
                    </div>
                    <div class="col-12">
            <button kendoButton style="background-color: #E8E6E3 !important;
                                        color: blue;
                                        font-weight: 700;
                                        padding:5px 30px !important;
                                        margin: 10px 25px;
                                        border-radius: 10px;
                                        width:90%"
                        (click)="_save()">Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
            @if (_invalidForm) {
              <div class="row">
                <div class="col-12">
                  <asap-forms-validation-summary
                    [form]="_form"
                    [page]="'cycle-count'">
                  </asap-forms-validation-summary>
                </div>
              </div>
            }
            <!-- Grid Data -->
            @if (_cycleCountGridData.length > 0) {
              <div class="col-12">
                <div class="asap-section-container with-grid"
                  (click)="_gridclicked()"
                  [class.active]="_addClassActiveGrid">
                  <div class="row zeromarginRow">
                    <div class="col-12">
                      <p class="titleStandardStyle margin-top-10">
                        <span>Items Count:</span>
                        <span class="autoGenerateSection">
                          <span>
                            {{_cycleCountGridData.length}}
                          </span>
                        </span>
                      </p>
                    </div>
                  </div>
                  <div #gridWrapper>
                    <kendo-grid [data]="_cycleCountGridData"
                      #grid
                      [resizable]="true"
                      class="asap-standalone-grid">
                      <kendo-grid-column field="assetName" title="Inventory #">
                      </kendo-grid-column>
                      <kendo-grid-column field="expectedLocationName" title="Expected Location">
                      </kendo-grid-column>
                      <kendo-grid-column field="assetActualLocationName" title="Actual Location">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <kendo-dropdownlist
                            [data]="_locations"
                            textField="code"
                            valueField="id"
                            [value]="getSelectedLocation(dataItem)"
                            (valueChange)="onLocationChange($event, dataItem)"
                          ></kendo-dropdownlist>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-column field="expectedPersonName" title="Expected Person">
                      </kendo-grid-column>
                      <kendo-grid-column field="actualPersonName" title="Actual Person">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <kendo-dropdownlist
                            [data]="_persons"
                            textField="personDisplay"
                            valueField="id"
                            [value]="getSelectedPerson(dataItem)"
                            (valueChange)="onPersonChange($event, dataItem)"
                          ></kendo-dropdownlist>
                        </ng-template>
                      </kendo-grid-column>
                      <kendo-grid-pdf
                        [fileName]="_exportFileName + '.pdf'"
                        paperSize="A4"
                        [allPages]="true"
                        [repeatHeaders]="true"
                        [landscape]="true"
                        [scale]="0.5">
                        <kendo-grid-pdf-margin top="2cm"
                          left="1cm"
                          right="1cm"
                          bottom="2cm">
                        </kendo-grid-pdf-margin>
                        @for (item of _pdfColumns; track item) {
                          <kendo-grid-column [title]="item.name" [field]="item.field">
                          </kendo-grid-column>
                        }
                      </kendo-grid-pdf>
                    </kendo-grid>
                  </div>
                </div>
              </div>
            }

          </div>


        </form>
